<template>
  <div>
    <loader v-if="loading" />
    <template v-else>
      <div>
        <!-- Info Guide -->
        <info-guide
          v-if="guideVisibleFirstTime"
          type="directCostsExamples"
          visible
          @click="closeInfoFirstTime"
        />
        <!-- /Info Guide -->

        <div class="d-flex justify-content-end margin-guide-not-visible" />
      </div>
    </template>

    <!-- Direct Costs Tabs -->
    <direct-costs-tabs v-if="!loading" class="mb-4" />
    <!-- /Direct Costs Tabs -->

    <!-- Direct Costs List -->
    <direct-costs-list class="mb-4" :disabled="aiTemplateLoader" />
    <!-- /Direct Costs List -->

    <!-- Add More Details -->
    <add-more-details
      v-if="!loading"
      :category="'forecast'"
      :step="'direct-costs'"
      :concept-name="'directCostsMoreDetails'"
      :completed-step-name="'directCostsCompleted'"
    />
    <!-- /Add More Details -->

    <!-- Info Guide Drawer -->
    <info-guide-drawer
      type="directCostsExamples"
      :visible="guideVisible"
      @close="guideVisible = false;"
    />
    <!-- /Info Guide Drawer -->

    <!-- Ai Buddy Drawer -->
    <ai-buddy-drawer
      :visible="aiBuddyDrawerVisible"
      type="direct-costs"
      @close="aiBuddyDrawerVisible = false"
    />
    <!-- /Ai Buddy Drawer -->
  </div>
</template>

<script>
import AddMoreDetails from '@/views/Home/StoryMode/Components/AddMoreDetails.vue'
import AiBuddyDrawer from '@/views/Home/StoryMode/Components/AiBuddy/AiBuddyDrawer.vue'
import DirectCostsList from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/DirectCost/DirectCostsList.vue'
import DirectCostsTabs from '@/views/Home/StoryMode/FinancialPlan/Components/Expenses/DirectCost/DirectCostsTabs.vue'
import EventBus from '@/event-bus'
import InfoGuide from '@/views/Home/StoryMode/Components/Example/InfoGuide.vue'
import InfoGuideDrawer from '@/views/Home/StoryMode/Components/Example/InfoGuideDrawer.vue'
import Loader from '@/components/Loader'
import MixinAiBuddyDrawer from '@/mixins/aiBuddyDrawer'
import MixinAiTemplate from '@/mixins/aiTemplate'
import MixinApiCalculations from '@/mixins/apiCalculations'
import MixinGuide from '@/mixins/guide'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'

export default {
  name: 'ExpensesDirectCosts',

  components: {
    AddMoreDetails,
    DirectCostsList,
    DirectCostsTabs,
    InfoGuide,
    AiBuddyDrawer,
    InfoGuideDrawer,
    Loader
  },

  mixins: [MixinApiCalculations, MixinGuide, MixinIdeaRoles, MixinAiBuddyDrawer, MixinAiTemplate],

  data () {
    return {
      loading: false,
      dialogAddNewVisible: false
    }
  },

  mounted () {
    this.openGuide('directCostFinancialPlanGuide')

    EventBus.$on('loading', (payload) => {
      this.loading = payload
    })

    EventBus.$on('open-info', () => {
      this.guideVisible = true
    })

    EventBus.$on('close-info-first-time', () => {
      this.guideVisibleFirstTime = false
    })
  },

  beforeDestroy () {
    EventBus.$off('loading')
    EventBus.$off('open-info')
    EventBus.$off('close-info-first-time')
  }
}
</script>
